import { createFileRoute } from '@tanstack/react-router';
import { getAuthtoken, getSelectedOrganizationId } from 'stores/useAuthStore';
import FunctionalTesting from 'containers/FunctionalTesting';
import { functionalTestsQueryOptions } from 'containers/FunctionalTesting/useFunctionalTesting';

export const Route = createFileRoute('/_authenticated/functionalTesting')({
  loader: ({ context }) => {
    const authToken = getAuthtoken();
    const organizationId = getSelectedOrganizationId();
    return context.queryClient.prefetchQuery(
      functionalTestsQueryOptions(
        { page: 0, pageSize: 50 },
        authToken,
        organizationId
      )
    );
  },
  component: FunctionalTesting,
});
